import Box from '@mui/material/Box';
import { RefObject } from 'react';

import { Drag } from 'assets/volvoIcons/Control/Drag';
import { Sxable } from 'library/types';
import { PCTheme } from 'library/utils/themes/PCTheme';

const {
	palette: {
		grey: { '400': grey400, '200': grey200, '100': grey100 },
	},
} = PCTheme;

export const DragHandler = ({
	sx,
	ref,
	...props
}: Sxable & { ref?: RefObject<HTMLButtonElement> }) => (
	<Box
		ref={ref}
		sx={[
			() => ({
				border: 'none',
				borderRadius: 1,
				cursor: 'grab',
				display: 'inline',
				padding: 0.25,
				paddingBottom: 0,
				background: 'transparent',
				'&:hover, &:active': {
					background: grey200,
					svg: {
						fill: grey100,
					},
				},
			}),
			...(Array.isArray(sx) ? sx : [sx]),
		]}
		{...props}>
		<Drag fontSize="small" htmlColor={grey400} />
	</Box>
);
